import React, { useEffect } from 'react';
import '../styles/IndustriesPage.css';
// import { Link } from 'react-router-dom';
import { allIndustriesData } from '../data/allIndustriesData';
import PageHeader from './PageHeader';
import IndustriesOffer from './IndustriesOffer';
import success1 from '../assets/industries-Images/success1.png';
import success2 from '../assets/industries-Images/success2.png';
import success3 from '../assets/industries-Images/success3.png';

const IndustriesPage: React.FC = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="industries-page">
  <PageHeader 
    heading='Industries We Serve' 
    text='At ReventLabs, we provide tailored technology solutions across diverse industries, leveraging our expertise to address sector-specific challenges and drive innovation. Our deep industry knowledge enables us to deliver customized solutions that help businesses achieve their strategic objectives and stay ahead in rapidly evolving markets.' 
  />

  {/* industries offer section */}
  <div className='industries-offer-section'>
    <p className='industries-section-title'>What Do We Offer in Cloud FinOps Consulting?</p>

    <IndustriesOffer
          items={Object.values(allIndustriesData)}
          idKey="id"
          imagePath={(industry) => industry.hero.image}
          titlePath={(industry) => industry.hero.title}
          descriptionPath={(industry) => industry.hero.description}
          highlightsPath={(industry) => industry.hero.highlights || []}
          linkPath={(industry) => `/industries/${industry.id}`}
        />
  </div>

  {/* Case Studies Section */}
  <div className="success-story-section">
    <div className='success-story'>
      <h3 className="industries-section-title">Success Stories</h3>
      
      <div className="success-story-grid">
        {/* Case Study 1 */}
        <div className="success-story-part">
          <img src={success1} alt="" />
          
          <div className="success-story-content">
            <h4 className="success-story-title">Medical Records Modernization</h4>
            <p className="success-story-text">
              We helped a leading healthcare provider transition from legacy systems to a modern, HIPAA-compliant electronic 
              health records platform, improving data accessibility while maintaining the highest security standards.
            </p>
          </div>

          <div className="success-story-results">
              <div className="success-story-result">
                <div className="success-story-result-number">65%</div>
                <div className="success-story-result-label">Faster Access</div>
              </div>
              <div className="grid-divider"></div>
              <div className="success-story-result">
                <div className="success-story-result-number">40%</div>
                <div className="success-story-result-label">Cost Reduction</div>
              </div>
              <div className="grid-divider"></div>
              <div className="success-story-result">
                <div className="success-story-result-number">99.9%</div>
                <div className="success-story-result-label">Uptime</div>
              </div>
            </div>
        </div>

        <div className="success-gradient-hr"></div>

        {/* Case Study 2 */}
        <div className="success-story-part">
          <img src={success2} alt="" />
          
          <div className="success-story-content">
            <h4 className="success-story-title">Fraud Detection System</h4>
            <p className="success-story-text">
              We developed an AI-powered fraud detection system for a financial institution that analyzes transaction patterns 
              in real-time, significantly reducing fraudulent activities while minimizing false positives.
            </p>
          </div>

          <div className="success-story-results">
              <div className="success-story-result">
                <div className="success-story-result-number">87%</div>
                <div className="success-story-result-label">Fraud Reduction</div>
              </div>
              <div className="grid-divider"></div>
              <div className="success-story-result">
                <div className="success-story-result-number">92%</div>
                <div className="success-story-result-label">Detection Rate</div>
              </div>
              <div className="grid-divider"></div>
              <div className="success-story-result">
                <div className="success-story-result-number">5ms</div>
                <div className="success-story-result-label">Response Time</div>
              </div>
            </div>
        </div>

        <div className="success-gradient-hr"></div>

        {/* Case Study 3 */}
        <div className="success-story-part">
          <img src={success3} alt="" />
          
          <div className="success-story-content">
            <h4 className="success-story-title">IoT Predictive Maintenance</h4>
            <p className="success-story-text">
              We implemented an IoT-based predictive maintenance solution for a global manufacturer, leveraging sensor data 
              and machine learning to predict equipment failures before they occur and optimize maintenance schedules.
            </p>           
          </div>

          <div className="success-story-results">
            <div className="success-story-result">
              <div className="success-story-result-number">73%</div>
              <div className="success-story-result-label">Downtime Reduction</div>
            </div>
            <div className="grid-divider"></div>
            <div className="success-story-result">
              <div className="success-story-result-number">32%</div>
              <div className="success-story-result-label">Maintenance Savings</div>
            </div>
            <div className="grid-divider"></div>
            <div className="success-story-result">
              <div className="success-story-result-number">18%</div>
              <div className="success-story-result-label">Productivity Gain</div>
            </div>
          </div>
        </div>
        <div className="success-gradient-hr"></div>

      </div>
    </div>
  </div>
</div>
  );
};

export default IndustriesPage; 